import deepmerge from "deepmerge";
import prodEnv from "./env.prod";

export default deepmerge(prodEnv, {
	stage: "dev",
	hostUrl: "https://dev-app.ambifi.com",
	pingUrl: "https://w1scc0oz5l.execute-api.us-east-1.amazonaws.com/dev/ping",
	assetsUrl: "https://dev-assets.ambifi.com",
	stripe: {
		key: "pk_test_OLIBXG28fbBQ1BBpxPWdVRKe"
	},
	s3: {
		contentBucket: "dev.content.ambifi.com",
		converterBucket: "dev.converter.ambifi.com",
		assetsBucket: "dev-assets-ambifi-com",
		athenaResultsBucket: "dev-athena-query-results-ambifi-com",
		ambiFiLearningKey: "173e7df4-ebb4-4abd-9fc5-7f4b1ffc4784",
		ambiFiLearningContentStructure: "b672d73d-1760-43e4-862f-031e9ba6f2ef",
		userUploadBucket: "dev-upload-ambifi-com"
	},
	mysql: {
		historyTable: "history"
	},
	cognito: {
		userPoolId: "us-east-1_5MYlfK1FW",
		clientId: "312v2dhdff7a2t5tu5nanuefo9",
		identityPoolId: "us-east-1:24f1f0df-c16d-43a6-ad23-07514c419c63",
		loginContext: "cognito-idp.us-east-1.amazonaws.com/us-east-1_5MYlfK1FW"
	},
	algolia: {
		applicationId: "A6ZL85XHSB",
		apiKey: "bc405007e72359e4f88da6bc04a0673c",
		apiKey2: "1d3430002be29a0a2b9d09230a2bfb84",
		index: "dev_AmbiFi",
		indexHistory: "dev_HISTORY"
	},
	cloudFront: {
		assetUrls: {
			public: "https://dev-public-assets.ambifi.com",
			private: "https://dev-private-assets.ambifi.com"
		}
	},
	apiGateway: {
		baseUrl: "https://w1scc0oz5l.execute-api.us-east-1.amazonaws.com/dev",
	},
	dynamoDb: {
		userHistoryTable: "UserHistory"
	},
	lambda: {
		importCsvFunction: "ambifi-csv-import-lambda-web-dev",
		extractHistoryCsvFunction: "ambifi-history-csv-extract-lambda-dev"
	},
	config: {
		useFancyAlerts: true,
		defaultPlan: "pro-plan-unlimited"
	},
	google: {
		apiKey: "AIzaSyB8F8WiJBwuSPTdj0BDZT-mHbhupgP-IHk"
	}
});